import request from '@/utils/request'

// 商品列表列表
export function fetchList(data) {
	return request({
		url: '/oms/goods/list',
		method: 'POST',
		data
	})
}

// 商品上架
export function goodsOnSale(data) {
	return request({
		url: '/oms/goods/onSale',
		method: 'POST',
		data
	})
}

//ShopifyCsv导出
export function exportShopifyCsv(data){
	return request({
		url: '/oms/shopify/goods/export/csv',
		method: 'POST',
		responseType: 'blob',
		data
	})
}

//ShopifyCsv导入
export function importShopifyCsv(data) {
	return request({
		url: '/oms/shopify/goods/import/csv',
		method: 'POST',
		data
	})
}

export function countPendingImport(){
	return request({
		url: '/oms/shopify/goods/import/pending/count',
		method: 'GET'
	})
}


// 商品下架
export function goodsOffSale(data) {
	return request({
		url: '/oms/goods/offSale',
		method: 'POST',
		data
	})
}

// 商品信息
export function goodsEditInfo(params) {
	return request({
		url: '/oms/goods/get',
		method: 'GET',
		params
	})
}

// 商品属性删除
export function deleteSizeAttr(params) {
	return request({
		url: '/oms/size/delete',
		method: 'POST',
		params
	})
}

//获取下单失败列表
export function orderFiList(data) {
	return request({
		// url: '/scm/goods/demand/problemDemandList', //http://scm.jollybuyer.com/api/scm/goods/demand/platformProblemDemandList
		url: '/scm/goods/demand/platformProblemDemandList',
		method: 'POST',
		data
	})
}
// 标记问题
export function signDemand(data) {
	return request({
		url: '/scm/goods/demand/problemDemand/oos',
		method: 'POST',
		data
	})
}
// 重新采购 /scm/goods/demand/problemDemand/repurchase
export function repurChase(data) {
	return request({
		url: '/scm/goods/demand/problemDemand/repurchase',
		method: 'POST',
		data
	})
}


// 更新采购链接
export function updatePurchaseLink(data) {
	return request({
		url: '/scm/goods/demand/updatePurchaseLink',
		method: 'POST',
		data
	})
}
// 导出



// WEBPACK FOOTER //
// ./src/api/gm/goods.js